import { render, staticRenderFns } from "./BankaythView.vue?vue&type=template&id=db96c65c&scoped=true&"
import script from "./BankaythView.vue?vue&type=script&lang=js&"
export * from "./BankaythView.vue?vue&type=script&lang=js&"
import style0 from "./BankaythView.vue?vue&type=style&index=0&id=db96c65c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db96c65c",
  null
  
)

export default component.exports